export default "__VITE_ASSET__5TFhCQff__";